module.exports = __webpack_public_path__ + "img/phone.271255f3.png";